/**
 * B1083 — one `<script type="application/ld+json">` in <head>, kept equal to
 * the page's current document and removed when the page has none. The id
 * keeps it ONE: a re-render replaces the text, never adds a second block.
 */
import { useEffect } from "react";
import { jsonLdText } from "./jsonLd.js";

export const JSON_LD_SCRIPT_ID = "transact-jsonld";

export function useJsonLd(doc: { readonly [key: string]: unknown } | undefined): void {
  useEffect(() => {
    if (typeof document === "undefined") return;
    const existing = document.getElementById(JSON_LD_SCRIPT_ID);
    if (doc === undefined) {
      existing?.remove();
      return;
    }
    const script = existing instanceof HTMLScriptElement ? existing : document.createElement("script");
    script.id = JSON_LD_SCRIPT_ID;
    script.type = "application/ld+json";
    const text = jsonLdText(doc);
    if (script.textContent !== text) script.textContent = text;
    if (script.parentNode === null) document.head.appendChild(script);
  }, [doc]);
  useEffect(() => () => document.getElementById(JSON_LD_SCRIPT_ID)?.remove(), []);
}
